
export default {
    namespaced: true,
    state: {
        tablePagination: {
            current: 1,
            pageSize: 10, // Default number of rows per page
            showSizeChanger: false, // Enable the page size changer,
            
        }
    },
    mutations: {
        updatePageSize(state, payload) {
            state.tablePagination.pageSize = payload

        },


        updatePagination(state, payload) {
            console.log("updatePagination payload", payload)
            
            state.tablePagination = {
                ...payload,
                showSizeChanger: false,


            }

        },


    },
    actions: {

        updatePageSize(context, payload) {
            context.commit('updatePageSize', payload)
        },


        updatePagination(context, payload) {

            context.commit('updatePagination', payload)


        },



    },

    getters: {
        userName(state) {
            return state.user?.name || ''
        },

    }





}